import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCepList from './CepList.hook';
import { CepListFilters, GridStyle } from './CepList.style';
import GridList from 'modules/maya/components/GridList/GridList';
import MayaLayout from 'modules/maya/components/MayaLayout';
import { useYodaCreateForm, YodaFormProvider } from 'services/yodaForm';
import Box from 'yoda-ui/Box';
import ConfirmationDialog from 'yoda-ui/Dialogs/ConfirmationDialog';
import MultiSelectYoda from 'yoda-ui/Form/SelectYoda/MultiSelectYoda';
import TextYoda from 'yoda-ui/Form/TextYoda';
import Loader from 'yoda-ui/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const CepList: FC = () => {
  const { providerFields } = useYodaCreateForm();
  const { t } = useTranslation();

  const {
    cepListColumnConfig,
    cepLoading,
    cepTitleFieldConfig,
    customerInitiativeFieldConfig,
    debouncedHandleChangeCepTitle,
    deleteCepCallback,
    getFilteredRows,
    handleChangeCI,
    handleChangeStatus,
    handleClick,
    menuCustomerEngagementPlanningLabel,
    newElementButton,
    onPageChange,
    onPageSizeChange,
    open,
    removeCepLoading,
    rowCountState,
    rowId,
    setOpen,
    statusFieldConfig,
  } = useCepList();

  return (
    <MayaLayout>
      <GridList
        sx={ GridStyle }
        loading={ cepLoading }
        getRowId={ (row) => row._id }
        onCellClick={ handleClick }
        title={ menuCustomerEngagementPlanningLabel }
        columnConfig={ cepListColumnConfig }
        rows={ getFilteredRows() }
        onPageChange={ onPageChange }
        onPageSizeChange={ onPageSizeChange }
        rowCountState={ rowCountState }
        newElementButton={ newElementButton }
        customFilters={
          (
            <YodaFormProvider { ...providerFields }>
              <Box sx={ CepListFilters }>
                <TextYoda
                  onChange={ debouncedHandleChangeCepTitle }
                  { ...cepTitleFieldConfig } />
              </Box>
              <Box sx={ CepListFilters }>
                <MultiSelectYoda
                  onChange={ handleChangeStatus }
                  { ...statusFieldConfig } />
              </Box>
              <Box sx={ CepListFilters }>
                <MultiSelectYoda
                  onChange={ handleChangeCI }
                  { ...customerInitiativeFieldConfig } />
              </Box>
            </YodaFormProvider>
          )
        }
        disableColumnMenu={ true }
      />
      {
        open && (
          <ConfirmationDialog
            dialogTitle={ t('maya_cep_modal_remove') }
            onConfirm={
              () => {
                deleteCepCallback(rowId);
              }
            }
            onConfirmLabel={ removeCepLoading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : t('actions_confirm_label') }
            onDismiss={ () => setOpen(false) }
            onDismissLabel={ t('actions_cancel_label') }
          >
          </ConfirmationDialog>
        )
      }
    </MayaLayout>
  );
};

export default CepList;
